export const ru = {
    'default-error': 'Некорректно заполнены данные'
};
